<script>
    import {onDestroy, createEventDispatcher, setContext, getContext} from 'svelte';
    import {ReportAPI} from '../api/report';
    import DropdownButton from "@manaakiwhenua/frag-svelte/src/toolbar/DropdownButton.svelte";
    import {writable} from "svelte/store";

    export let reportId;
    export let dropdownVisible = false;
    export let dirty = false;
    export let disabled = false;
    export let reportTitle;

    let loading = false;
    let pdfJob;
    let pdfURL;
    let error;

    let controller;

    const reportSaved = getContext('reportSaved') || writable(false);

    function abortAny() {
        try {
            controller.abort();
            controller = undefined;
        } catch (e) {

        }
    }

    $: revision = $reportSaved;

    let pdfRevision = 0;

    function startQueuePolling() {
        const api = new ReportAPI();
        loading = true;

        abortAny();
        controller = new AbortController();

        function poll() {
            api.fetchReportPDF(pdfJob, controller.signal)
                .then(async r => {
                    if (r.status === 200) {
                        pdfURL = URL.createObjectURL(await r.blob());
                        pdfRevision = revision;
                        loading = false;
                        return;
                    }
                    if (r.status === 202) {
                        setTimeout(poll, 1000);
                    }
                })
                .catch(err => {
                    console.error(err);
                    error = err;
                    loading = false;
                })
        }

        poll();
    }

    function fetchReportPDF() {
        const api = new ReportAPI();

        loading = true;
        abortAny();
        controller = new AbortController();
        api.enqueueReportPDF(reportId, controller.signal)
            .then(async response => {
                if (response.status === 202) {
                    const data = await response.json();
                    pdfJob = data.reportPdfUuid;
                    startQueuePolling();
                } else if (response.status === 200) {
                    pdfURL = URL.createObjectURL(await response.blob());
                    pdfRevision = revision;
                    loading = false;
                }
            })
            .catch(err => {
                console.error(err);
                error = err;
                loading = false;
            });
    }

    const dispatch = createEventDispatcher();

    $: if (pdfRevision < revision && pdfURL) {
        URL.revokeObjectURL(pdfURL);
        pdfURL = null;
    }

    function handleToggle (event) {
        dispatch('change', event.detail);
        if (!event.detail || loading || pdfURL) return;
    }

    function retry() {
        error = undefined;
        fetchReportPDF();

    }

    $: if (dropdownVisible && !(loading || pdfURL || error)) {
        fetchReportPDF();
    }


    $: title = !disabled ? "Get a PDF of this report" : "Disabled until you save/cancel your changes";

    onDestroy(function () {
        if (pdfURL) {
            URL.revokeObjectURL(pdfURL);
        }

        abortAny();
    });
</script>

<style>
    span > i.icon.icon-spinner {
        width: auto;
        vertical-align: middle;
        height: auto;
    }

    a > i.icon {
        vertical-align: middle;
    }

    a > i.icon:hover {
        background: transparent !important;
    }
</style>

<DropdownButton {title}
                bind:dropdownVisible
                {disabled}
                on:change={handleToggle}>
    <i slot="icon"
       let:dropdownVisible
       class:active={dropdownVisible}
       class="icon icon-print"
       data-action="reportPDFButton"></i>

    <!--
    let:dropdownVisible
    class:active={dropdownVisible}-->

    <div slot="dropdownContent">
        {#if loading}
            <span>
                <i class="icon icon-spinner spinning"></i>
                generating PDF
            </span>
        {:else if pdfURL}
            <a href={pdfURL} download={reportTitle + ".pdf"}>
                <i class="icon icon-file-pdf"></i>
                Download PDF
            </a>
        {:else}
            <p>
                Failed to generate PDF.
            </p>

            <button on:click={retry}
                    class="flat flat-default">
                Retry
            </button>
        {/if}
    </div>
</DropdownButton>
